<script setup>
import {Form, useForm} from 'vee-validate'
import * as yup from "yup"
import {useContactApi} from "~/composables/api/useContactApi";

const subscribeNewsletterSchema = yup.object({
  email: yup.string().required().email().label('Correo Electrónico'),
  terms: yup
    .boolean()
    .required()
    .isTrue('Debes aceptar los términos y condiciones')
    .label('Términos y Condiciones'),
})
const notification = useNotification()
const contactApi = useContactApi()
const formData = ref({
  email: '',
  terms: false
})
const sending = ref(false)
const {errors} = useForm({
  validationSchema: subscribeNewsletterSchema,
})

async function onSubmit() {
  try {
    sending.value = true
    const contactData = {
      referer: window.location.href,
      firstname: '-',
      lastname: '-',
      email: formData.value.email,
      phone: '-',
      subject: 'Solicitud alta Newsletter',
      message: 'Quiero darme de alta en la newsletter de Diprofem con el email '+formData.value.email
    }

    await contactApi.send(contactData)
    sending.value = false
    notification.showSuccess(`La suscripción se ha tramitado correctamente para el email ${formData.value.email}`)
    formData.value.email = ''
    formData.value.terms = false
  } catch (error) {
    notification.showError(error)
    sending.value = false
  }
}
</script>

<template>
  <Form class="flex flex-col items-center w-full sm:w-[50%] mx-auto" @submit="onSubmit">
    <div class="mb-5 w-full">
      <h5 class="uppercase italic text-md lg:text-xl font-bold text-center">SUSCRÍBETE A NUESTRA NEWSLETTER</h5>
    </div>
    <FloatLabel class="mb-3 w-full">
      <InputText id="subemail" class="p-2 text-md italic w-full" type="email" v-model="formData.email"
                 :class="{ 'p-invalid': errors.email }"/>
      <label for="email">Correo Electrónico</label>
    </FloatLabel>
    <div class="mb-3 w-full flex justify-start items-center text-md">
      <Checkbox
        id="terms"
        class="mr-2"
        v-model="formData.terms"
        :class="{ 'p-invalid': errors.terms }"
        binary
      />
      <label class="text-[0.8rem] lg:text-[1rem]" for="terms">He leído y acepto los <a class="underline" href="/politica-de-privacidad" target="_blank">términos
        y condiciones</a></label>
    </div>
    <button class="my-3" type="submit"><span
      class="w-full text-white bg-[#dcd6ce] !text-[#363330] text-lg italic px-5 py-2 rounded-[8px]">Suscribirse</span></button>
  </Form>
</template>
